<template>
  <div class="BoxWide">
    <div class="Filter">
      <form>
        <fieldset>
          <legend>Filtra per:</legend>
          <div class="FormRow">
          <!--<div class="FormBox25" v-show="this.showStatoFilter">
              <label>Stato</label>
              <select class="CustomSelect NoSearch" name="" id="selStatiIntervento">
                <option value="all">Tutti</option>
                <option v-for="(stato, index) in this.$store.getters.getStatiIntervento" :key="index" :value="stato.Codice">{{ stato.Descrizione }}</option>
              </select>
            </div>-->
            <div class="FormBox25">
              <label>Sito</label>
              <select class="CustomSelect NoSearch" name="" id="SelectSiti">
                <option value="all">Tutti</option>
                <option v-for="(sito, index) in this.$store.getters.getSiti" :key="index" :value="sito.CodiceSito">{{ sito.DescrizioneOperativa }}</option>               
              </select>
            </div>
            <div class="FormBox25">
              <label>Data fino a</label>
              <input type="date" id="" name="" placeholder="Inserisci la data" v-model="this.dataSelected"/>
            </div>
            <div class="FormBox25">
              <div class="TwinButtons">
                <div class="Button ExtraSmall">                  
                  <input type="button" id="" name="" value="Filtra" @click="this.filtraInterventi()" />
                </div>
                <div class="Button ExtraSmall">
                  <a href="javascript:void(0)" @click="this.rimuoviFiltri">Rimuovi filtri</a>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
</template>

<script>

import FiltroModelliEventData from "@/models/filtroModelliEventData.model.js";

export default {
  name: "FiltroInterventi",
  data() {
    return {
      sitoSelected: "",
      statoSelected: "",
      dataSelected: ""
    }
  },
  props:{
      showStatoFilter: Boolean
  },
  methods: {
    filtraInterventi: function(){
      this.sitoSelected =  $('#SelectSiti').select2('data')[0].id;        

      this.$emit("FiltraInterventi", new FiltroModelliEventData( this.sitoSelected, null, this.dataSelected));
    },
    rimuoviFiltri: function(){
      $('#SelectSiti').val("all").trigger('change');
      $('#selStatiIntervento').val("all").trigger('change');
      this.dataSelected = "";
      this.sitoSelected = "all";
      this.$emit("RimuoviFiltri");
    }
  },
  mounted: function(){
    $(document).ready(function() {
      $('.CustomSelect').select2({
        theme: "classic"
      });

      $('.CustomSelect').on('select2:select', function (e) {
          var codiceSito = e.params.data.id;
          $("#sitoSelected").val(codiceSito);
      });

    });
  }
  
};
</script>

<style>
input[type="date"]{-webkit-appearance:none;appearance:none;}
input[type="date"]{width:100%;}
input[type="date"]{background-color:#ffffff;border:1px solid #cccccc;box-shadow:0 0 6px 0 rgba(0,0,0,0.00) inset;border-radius:0;font-family:'Open Sans', sans-serif;font-size:13px;color:#252525;}
input[type="date"]{height:36px;padding-top:3px;padding-right:12px;padding-bottom:3px;padding-left:12px;}npm 
input[type="date"]:focus{border-color:#e10712;box-shadow:0 0 6px 0 rgba(0,0,0,0.00) inset;}
</style>